// Copyright (c) 2026 Endel Dreyer.
//
// This software is released under the MIT License.
// https://opensource.org/license/MIT
//
// colyseus.js@0.18.2
/** Build the Error a rejected `request` throws. `faulted:false` → a deliberate
 *  `ctx.reject(reason)`: `name:"rejected"`, `.reason` = the raw typed reason.
 *  `faulted:true` → a server fault: an Error rebuilt from the sanitized
 *  `{ name, message, code }` payload. */
function toRequestError(payload, faulted) {
    if (!faulted) {
        const error = new Error("request rejected");
        error.name = "rejected";
        error.reason = payload;
        return error;
    }
    const error = new Error(payload?.message ?? "request failed");
    if (payload?.name) {
        error.name = payload.name;
    }
    if (payload?.code !== undefined) {
        error.code = payload.code;
    }
    return error;
}

export { toRequestError };
//# sourceMappingURL=RoomRequest.mjs.map
